import { Pipe, PipeTransform } from '@angular/core';

/**
 * 値がNULLや空でない場合のみ接尾辞を付与するパイプ.
 */
@Pipe({
  name: 'suffix'
})
export class SuffixPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (args.length > 0) {
      if (null != value && undefined !== value && '' !== value) {
        return value + args[0];
      }
    }
    return null;
  }
}
